<template>
  <div class="command-center-map">
    <div id="map-container"></div>
    <div class="header">
      <img @click="switchIcon(i)" v-for="i in header_icon" :src="mapConfig.show_types.includes(i.value) ? i.url : i.url1" alt="" :key="i.url">
      <el-button type="primary" :disabled="cameraDataList.length==0" @click="choosedCamera" :class="isChoosedStatus?'camera-btn-active':'camera-btn'">框选摄像机播放</el-button>
    </div>
    <div class="left-box" v-if="show">
      <div class="box1"><span style="opacity: .5;" @click="$router.push('/command/contaniner')">业务受理</span><label>|</label><span>应急联动</span></div>
      <div v-if="alarmId" class="box-content">
        <div class="box2" >
          <span v-for="i in left_menu.list" @click="selectMapMenu(i.id)" :key="i.id" :class="{selected: i.id === left_menu.selected_id}">{{i.text}}</span>
        </div>
        <div class="box3" >
          <ALARM_INFORMATION :alarmInfo="alarmInfo" v-if="left_menu.selected_id === '1'&&showInfo"></ALARM_INFORMATION>
          <LINKAGE @getTrack="showUserTrack" v-if="left_menu.selected_id === '2'"></LINKAGE>
          <Log v-if="left_menu.selected_id === '3'"></Log>
          <HiSTORY_EVENT v-if="left_menu.selected_id === '4'"></HiSTORY_EVENT>
        </div>
      </div>
      <div v-else class="null-info">
        <span class="iconfont iconkong"></span>
        <span>没有正在处理的警情哦！</span>
      </div>
    </div>
    <div class="search-box">
      <input v-model="search.camera_name" type="text" placeholder="请输入摄像机名称或地址进行搜索">
      <span @click="searchBntClick()">搜索</span>
    </div>


    <div id='user-tooltip' v-show="mapConfig.show_police_tooltip">
      <i class="el-icon-error" @click="mapConfig.show_police_tooltip = false"></i>
      <img :src="mapConfig.police_data.portrait" alt="">
      <div class="info-box">
        <p><span>姓名</span>&nbsp;:<span>{{mapConfig.police_data.realName}}</span></p>
        <p><span>联系方式</span>&nbsp;:<span>{{mapConfig.police_data.phone}}</span></p>
        <p><span>地址</span>&nbsp;:<span>{{mapConfig.police_data.centerName}}</span></p>
      </div>
      <button @click="showUserTrack()">查看轨迹</button>
    </div>

    <!-- 图文报警弹窗 -->
    <el-dialog :visible.sync="showPicAlarmInfo" width="500px" :before-close="closePicAlarm" title="图文报警详情" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- <AlarmDetailBox :alarm-detail-data="alarmInfo"></AlarmDetailBox> -->
      <div class="clus">
        <span>时间：</span>
        <span>{{alarmInfo.happenDate}}</span>
      </div>
      <div class="clus">
        <span>地点：</span>
        <span>{{alarmInfo.address}}</span>
      </div>
      <div class="clus">
        <span>描述：</span>
        <span>{{alarmInfo.realName}}</span>
      </div>
      <info bgColor="rgb(242, 242, 242)" :file="alarmInfo.files" :content="alarmInfo.content"/>
    </el-dialog>


    <div class="search-box1" v-if="userTrackShow">
      <div class="block" style="width: inherit;">
        <div class="major">轨迹播放控制
          <div class="closeInfo" @click="hideUserTrack">X</div>
        </div>
        <el-date-picker
            v-model="value1"
            type="date"
            placeholder="选择日期" style="margin: 10px">
        </el-date-picker>
        <button class="btn" @click="getTrack">播放轨迹</button>
        <button class="btn" @click="pauseAnimation">暂停动画</button>
        <button class="btn" @click="resumeAnimation">继续动画</button>
        <button class="btn" @click="stopAnimation">停止动画</button>
      </div>
    </div>
  </div>

</template>

<script>
import moment from 'moment';
import AMap from 'AMap'
import ALARM_INFORMATION from './alarm-information/alarm-infomation'
import LINKAGE from './linkage/linkage'
import Log from './log/log'
import HiSTORY_EVENT from './history-event/history-event'
import {mapAPI,listAPI} from '../../../../api-path/command-center.js'
import {GISApi} from '../../../../api-path/timeGis-api.js'
import publicAPI from '@/api-path/public-api.js'
import AlarmDetailBox from '../comand-center-contaniner/alarm-detail-box/alarm-detail-box.vue'
import Info from './help-info.vue'
import Button from "@/components/Button/Button";

let carInfo;
export default {
  name: "command-center-map",
  components: {
    Button,
    ALARM_INFORMATION,
    LINKAGE,
    Log,
    HiSTORY_EVENT,
    AlarmDetailBox,
    Info
  },
  data() {
    return {
      showInfo:true,
      /*图文报警*/
      showPicAlarmInfo:false,
      alarmInfo:'',
      /* 左侧菜单 */
      left_menu: {
        selected_id: '1', // 选中标识
        list: [
          {
            text: '报警信息',
            id: '1'
          }, {
            text: '联动处理',
            id: '2'
          }, {
            text: '报警日志',
            id: '3'
          }, {
            text: '历史事件',
            id: '4'
          },
        ], // 列表
      },

      /* 报警提示框 */
      alarmBoxShow: false,

      show: true,

      /* 查询条件 */
      search: {
        camera_name: ''
      },

      /* 地图相关 */
      mapConfig: {
        map: null, // 地图实列
        zoom: 8,
        oldZoom: '',
        areaId: '51',
        oldAreaId: '51',
        oldCenter: '',
        zoomDifference: 0, // 缩放层级差值
        show_types: ['出警人员'], // 显示类型
        camera_marker: [], // 摄像头标记
        camera_gather_marker: [], // 摄像头聚合
        event_help_marker: [], // 求助事件标记
        event_help_gather_marker: [], // 求助事件聚合
        event_alarm_gather_marker: [], // 报警事件聚合
        event_alarm_marker: [], // 报警事件标记
        police_marker: [], // 出警人员
        InfoWindow: null, // 详细信息框
        markerTimeOut: null, // 延时绑定移动事件
        show_police_tooltip: false, // 显示出警人员提示框
        police_data: {}, // 出警人信息
        police_track: false, // 是否正在显示轨迹
      },

      /* 地图顶部图标 */
      header_icon: [
        {
          start: false,
          value: '出警人员',
          url: require('../../../../assets/images/command-center/警察.png'),
          url1: require('../../../../assets/images/command-center/警察1.png')
        },{
          start: true,
          value: '摄像头',
          url: require('../../../../assets/images/command-center/摄像头.png'),
          url1: require('../../../../assets/images/command-center/摄像头1.png'),
        },{
          start: false,
          value: '报警事件',
          url: require('../../../../assets/images/command-center/报警.png'),
          url1: require('../../../../assets/images/command-center/报警1.png')
        },{
          start: false,
          value: '求助事件',
          url: require('../../../../assets/images/command-center/求助.png'),
          url1: require('../../../../assets/images/command-center/求助1.png'),
        },
      ],

      // 报警事件定位
      alarmPosition:"",
      alarmInfoMarker:[],

      //框选摄像机播放
      isChoosedStatus:false,//是否框选摄像机状态
      cameraDataList:[],//marker摄像机列表
      mouseTool:'',//框选工具
      choosedTool:'',//框选信息
      value1: '',//右下角时间

      userTrackShow: false,//右下角时间
      checkUserId:'',//查询轨迹用户的id
    }
  },
  computed: {
    alarmId() {
      return this.$store.state.alarmId
    }
  },
  watch: {
    alarmId: function(newd) {
      const t = this
      this.show = false
      setTimeout(function () {
        sessionStorage.setItem('groupId', newd)
        t.show = true
      }, 100)
      this.getAlarmDetail()
    },
  },
  mounted() {
    this.left_menu.selected_id = sessionStorage.getItem('MAP_Left_MENU') || '1'
    this.initMap();
    let alarmInfo=JSON.parse(sessionStorage.getItem('alarmInfo'));
    if(alarmInfo){
      if(sessionStorage.getItem('groupId')&&alarmInfo.alarmType=='1'){//一键报警
        this.$http.get(`${publicAPI.getAlarmStream}?alarmId=${sessionStorage.getItem('groupId')}`).then(res => {
          if (res.status === 200) {
            if (window.QCefClient) {
              res.result.type = 3
              res.result.userId = sessionStorage.getItem('userId')
              window.QCefClient.invokeMethod('QCef_Open_Player', 3, false, JSON.stringify(res.result))
            }
          }
        })
      }else if(alarmInfo.cameraId){//摄像头报警
        //调用查询摄像机的直播地址
        this.$http.post(GISApi.findLiveUrl,{cameraIds:[alarmInfo.cameraId]}).then(res=>{
          if(res.status==200){
            if (typeof window.QCefClient !== 'undefined') {
              for (let i = 0; i < res.result.length; i++) {
                res.result[i].storageUrl = GISApi.storageStatistics;
              }
              window.QCefClient.invokeMethod('QCef_Play_Rtsp',JSON.stringify({list: res.result}))
            }
          }
        })
      }else if(alarmInfo.alarmType=='2'){//图文报警
        this.showPicAlarmInfo=true;
        console.log(alarmInfo);
        this.alarmInfo=alarmInfo;
      }
    }else{
      this.getAlarmDetail()
    }
  },

  beforeDestroy() {
    // sessionStorage.removeItem('alarmInfo');
    sessionStorage.removeItem('eventUserId');
    sessionStorage.removeItem('MAP_Left_MENU');
    if (window.QCefClient) {
      window.QCefClient.invokeMethod('QCef_Close_Player')
    }
  },

  methods: {
    /*开始框选摄像机*/
    choosedCamera(){
      const $this=this;
      $this.isChoosedStatus=!$this.isChoosedStatus;
      if($this.isChoosedStatus){
        $this.mouseTool.rectangle({
          strokeColor:'red',
          strokeOpacity:0.5,
          strokeWeight: 6,
          fillColor:'blue',
          fillOpacity:0.5,
          strokeStyle: 'solid',
        }); //用鼠标工具画矩形
        $this.mouseToolListener=AMap.event.addListener( $this.mouseTool,'draw',function(e){ //添加事件
          if($this.choosedTool){
            $this.mapConfig.map.remove($this.choosedTool);
          }
          $this.choosedTool=e.obj;
          $this.getRectCameraInfo()
        });
      }else{
        $this.mouseTool.close();
        AMap.event.removeListener($this.mouseToolListener);
        if($this.choosedTool){
          $this.mapConfig.map.remove($this.choosedTool);
        }
      }
    },
    /*框选的摄像机信息*/
    getRectCameraInfo(){
      const $this=this;
      let data=[];
      $this.cameraDataList.forEach(item => {
        if($this.choosedTool.contains([item.longitude,item.latitude])){
          data.push(JSON.stringify(item))
        }
      })
      data = [...new Set(data)] // 数据去重
      let showChoosedCameraList=[];
      data.map(item=>{
        showChoosedCameraList.push(JSON.parse(item));
      })
      if(data.length!=0){
        let newData=[];
        if(data.length>16){
          newData= showChoosedCameraList.splice(0,16);
        }else{
          newData=showChoosedCameraList;
        }
        let ids=newData.map(item=>{
          return item.id;
        })
        this.$http.post(GISApi.findLiveUrl,{cameraIds:ids}).then(res=>{
          if(res.status==200){
            if (typeof window.QCefClient !== 'undefined') {

              for (let i = 0; i < res.result.length; i++) {
                res.result[i].storageUrl = GISApi.storageStatistics;
              }
              window.QCefClient.invokeMethod('QCef_Play_Rtsp',JSON.stringify({list: res.result}))
            }
          }
        })
      }
    },
    /*关闭图文报警弹窗*/
    closePicAlarm(){
      this.showPicAlarmInfo=false;
    },
    /*获取报警详情*/
    getAlarmDetail() {
      if(this.$store.state.alarmId){
        this.$http.get(listAPI.datail + '?alarmId=' + this.$store.state.alarmId).then(res => {
          this.alarmInfo = res.result
          let value=res.result;
          if(value){
            let alarmPosition=[value.longitude,value.latitude];
            this.alarmPosition=value;
            this.addAlarmInfoPosition(alarmPosition,value.type);
          }
        })
      }
    },
    addAlarmInfoPosition(position,type){
      // 添加标记
      let data={
        img : require('../../../../assets/images/command-center/alarm.png'),
        bgColor :'rgb(255 50 0)'
      };
      let map = this.mapConfig.map
      if(this.alarmInfoMarker){
        this.mapConfig.map.remove(this.alarmInfoMarker)
      }
      let AMarker = new AMap.Marker({
        position: position,
        content: this['markerIcon'](data),
        offset: new AMap.Pixel(-15, -15)
      })
      if(type==1){
        map.setCenter(position);
        this.alarmPosition.type=0;
      }
      AMarker.setAnimation('AMAP_ANIMATION_BOUNCE');
      this.alarmInfoMarker=[AMarker];
      map.add(AMarker);
    },
    /* 选择左侧菜单 */
    selectMapMenu(id) {
      this.left_menu.selected_id = id
      sessionStorage.setItem('MAP_Left_MENU', id)
    },

    /* 切换图标 */
    switchIcon(d) {
      let show_types = this.mapConfig.show_types
      if(show_types.includes(d.value)) {
        this.matchHideMarker(d.value)
        this.mapConfig.show_types = show_types.filter(item => item !== d.value)
      } else {
        this.matchShowMarker(d.value)
        show_types.push(d.value)
      }
    },

    /* 查询 */
    searchBntClick() {
      this.matchHideMarker('摄像头')
      this.getCamera()
    },

    /* 初始化地图 */
    initMap() {
      const $this=this;
      let initZoom = 8
      let mapConfig = $this.mapConfig
      mapConfig.map = new AMap.Map('map-container', {
        resizeEnable: true,
        zoom: initZoom,
        viewMode: '2D',
        layers: [new AMap.TileLayer()],
        zooms: [5, 18]
      })

      AMap.plugin(['AMap.MapType'], function() {
        const mapType = new AMap.MapType();   // 地图种类
        mapConfig.map.addControl(mapType);
      });

      mapConfig.map.on('zoomend', $this.zoomCount)
      AMap.plugin(["AMap.MouseTool"],function () {
        $this.mouseTool = new AMap.MouseTool($this.mapConfig.map);
      });
      mapConfig.show_types.forEach(item => {
        $this.matchShowMarker(item, mapConfig.areaId)
      })
      $this.moveOn()
      $this.getAlarmDetail()
    },

    /* 缩放 */
    zoomCount() {
      let map = this.mapConfig.map
      let mapConfig = this.mapConfig
      let zoom = map.getZoom()
      if (this.mapConfig.areaId.length >= 9 && zoom > 12) {
        this.markerUpData()
        this.mapConfig.zoom = this.mapConfig.map.getZoom()
        return;
      }
      this.moveOn()
      /* 相等 表示通过点击聚合进入的下级 */
      if (mapConfig.oldAreaId !== mapConfig.areaId) {
        this.markerUpData()
        this.mapConfig.zoom = this.mapConfig.map.getZoom()
        return;
      }
      this.getAreaCode()
    },

    /* 获取区域ID */
    getAreaCode() {
      this.$http.get(`${mapAPI.areaCode}?radius=1000&location=${this.mapConfig.map.getCenter()}`).then(res => {
        if (res.status === 200) {
          const towncode = res.result.regeocode.addressComponent.towncode
          const zoom = this.mapConfig.map.getZoom()
          if (zoom < 10) {
            this.mapConfig.areaId = towncode.slice(0, 2)
          }
          if (zoom >= 10) {
            this.mapConfig.areaId = towncode.slice(0, 4)
          }
          if (zoom === 12) {
            this.mapConfig.areaId = towncode.slice(0, 6)
          }
          if (zoom > 12) {
            this.mapConfig.areaId = towncode.slice(0, 9)
          }
          this.mapConfig.zoom = zoom
          this.mapConfig.zoomDifference = 0
          this.markerUpData()
        }
      })
    },

    /* 更新数据 */
    markerUpData() {
      if (this.mapConfig.police_track) {
        return
      }

      this.mapConfig.show_types.forEach(item => {
        this.matchShowMarker(item)
      })
      this.mapConfig.map.clearMap()
      this.mapConfig.show_police_tooltip = false
      this.mapConfig.oldAreaId = this.mapConfig.areaId;
      // this.getAlarmInfo(this.alarmPosition,0);
      this.getAlarmDetail()

    },

    /* 绑定事件（移动） */
    moveOn() {
      const t = this
      this.moveOff() // 解除移动事件
      t.mapConfig.markerTimeOut = setTimeout(function () {
        t.mapConfig.map.on('moveend', this.mapMoveend);
      }, 500)
    },

    /* 解除事件（移动）*/
    moveOff() {
      this.mapConfig.map.off('moveend', this.mapMoveend);
    },

    /* 移动事件 */
    mapMoveend() {
      this.markerUpData()
    },

    /* 匹配显示的标注 */
    matchShowMarker(value) {
      switch (value) {
        case '出警人员':
          this.getPolice()
          break;
        case '摄像头':
          this.getCamera()
          break
        case '报警事件':
          this.getAlarmEvent()
          break
        case '求助事件':
          this.getHelpEvent()
          break
      }
    },

    /* 匹配隐藏的标注 */
    matchHideMarker(value) {
      switch (value) {
        case '出警人员':
          this.clearPoliceMarker()
          break;
        case '摄像头':
          this.clearCameraMarker()
          this.clearCameraGatherMarker()
          break
        case '报警事件':
          this.clearAlarmMarker()
          this.clearEventAlarmGatherMarker()
          break
        case '求助事件':
          this.clearHelpEventMarker()
          this.clearEventHelpGatherMarker()
          break
      }
    },

    //  ------------ 数据查询 --------------------------

    /* 查询摄像头 */
    getCamera() {
      let zoom = this.mapConfig.map.getZoom()
      let params = {
        keyWord: this.search.camera_name,
        type: 'camera',
        limitedNum: '100',
        distance: '',
        areaId: this.mapConfig.areaId,
        zoom
      }
      params = zoom > 12 ? {...params, ...this.getBounds()} : params
      this.$http.get(mapAPI.camera, {params: params}).then(res => {
        if(res.result.data) {
          this.cameraDataInit(res.result)
        }
      })
    },

    /* 查询求助事件 */
    getHelpEvent() {
      let zoom = this.mapConfig.map.getZoom()
      let params = {
        type: 'help_event',
        limitedNum: '100',
        distance: '',
        areaId: this.mapConfig.areaId,
        zoom
      }
      params = zoom > 12 ? {...params, ...this.getBounds()} : params
      this.$http.get(mapAPI.helpEvent, {params: params}).then(res => {
        if(res.result.data) {
          this.helpEventDataInit(res.result)
        }
      })
    },

    /* 查询报警事件 */
    getAlarmEvent() {
      let zoom = this.mapConfig.map.getZoom()
      let params = {
        type: 'alarm',
        limitedNum: '100',
        distance: '',
        areaId: this.mapConfig.areaId,
        zoom
      }
      params = zoom > 12 ?  {...params, ...this.getBounds()} : params
      this.$http.get(mapAPI.alarm, {params: params}).then(res => {
        if(res.result.data) {
          this.alarmEventDataInit(res.result)
        }
      })
    },

    /* 查询出警人员 */
    getPolice() {
      this.$http.get(`${mapAPI.police}`).then(res => {
        if(res.result) {
          this.policeDataInit(res.result)
        }
      })
    },

    /* 摄像头数据处理 */
    cameraDataInit(result) {
      if (result.aggType) {    // 列表
        this.cameraDataList=result.data;
        result.data.forEach(item => {
          item.img = require('../../../../assets/images/command-center/camera.png')
          item.click = 'markerIcon'
          item.type = 'camera'
          item.hover= 'createCameraTooltip'
          item.bgColor = 'rgb(10 112 255)'
          item.marker_name = 'camera_marker'
          this.addMarker(item)
        })
      } else {   // 聚合
        this.cameraDataList=[];
        result.data.forEach(item => {
          item.click = 'gatherMarker'
          item.type = 'camera_gather'
          item.marker_name = 'camera_gather_marker'
          item.bgColor = 'rgb(10 112 255)'
          this.addMarker(item)
        })
      }
    },

    /* 求助事件数据处理 */
    helpEventDataInit(result) {
      if (result.aggType) {    // 列表
        result.data.forEach(item => {
          item.img = require('../../../../assets/images/command-center/help-event.png')
          item.click = 'markerIcon'
          item.hover = 'createEventTooltip'
          item.type = 'event_help'
          item.bgColor = 'rgb(255,153,0)'
          item.marker_name = 'event_help_marker'
          this.addMarker(item)
        })
      } else {   // 聚合
        result.data.forEach(item => {
          item.click = 'gatherMarker'
          item.type = 'help_event_gather'
          item.marker_name = 'event_help_gather_marker'
          item.bgColor = 'rgb(255,153,0)'
          this.addMarker(item)
        })
      }
    },

    /* 报警事件数据处理 */
    alarmEventDataInit(result) {
      if (result.aggType) {    // 列表
        result.data.forEach(item => {
          item.img = require('../../../../assets/images/command-center/alarm.png')
          item.click = 'markerIcon'
          item.hover = 'createEventTooltip'
          item.type = 'alarm'
          item.bgColor = 'rgb(255 50 0)'
          item.marker_name = 'event_alarm_marker'
          this.addMarker(item)
        })
      } else {   // 聚合
        result.data.forEach(item => {
          item.click = 'gatherMarker'
          item.type = 'help_event_gather'
          item.marker_name = 'event_alarm_gather_marker'
          item.bgColor = 'rgb(255 50 0)'
          this.addMarker(item)
        })
      }
    },

    /* 出警人员数据处理 */
    policeDataInit(result) {
      result.forEach(item => {
        item.img = require('../../../../assets/images/command-center/user-icon.png')
        item.click = 'markerIcon'
        item.hover = 'createPoliceTooltip'
        item.type = 'police'
        item.tooltipOffset = {
          offsetX: 260,
        }
        item.bgColor = '#06699b'
        item.marker_name = 'police_marker'
        this.addMarker(item)
      })
    },

    /* 获取可视范围的边界 */
    getBounds() {
      let bounds = this.mapConfig.map.getBounds();
      let position = {
        bottomLat: bounds.southwest.lat, // 底部的纬度
        lonLeft: bounds.southwest.lng, // 左经度
        lonRight: bounds.northeast.lng, //右经度
        topLat: bounds.northeast.lat, // 最高纬度
      }
      return position
    },

    /* 获取人员轨迹 */

    showUserTrack(id){
      this.checkUserId=id;
      this.userTrackShow=true;
    },
    hideUserTrack(){
      this.userTrackShow=false;
    },


    //轨迹暂停
    pauseAnimation() {
      carInfo.pauseMove();
    },

    //轨迹恢复
    resumeAnimation() {
      carInfo.resumeMove();
    },

    //轨迹停止
    stopAnimation() {
      carInfo.stopMove();
    },

    getTrack() {
      console.log("check id-->"+this.checkUserId);
      if(this.value1==null || this.value1=='' || this.value1==undefined){
        this.$message.error('请选择日期！')
      }else{
        let infoDate = moment(this.value1).format('YYYY-MM-DD');
        const params = {
          startDate: infoDate,
          userId: this.checkUserId || this.mapConfig.police_data.id
        }
        this.$http.get(mapAPI.userTrack, {params}).then(res => {
          if(res.status==200) {
            if(res.result){
              this.mapConfig.police_data.position = []
              res.result.forEach(item => {
                this.mapConfig.police_data.position.push([item.longitude, item.latitude])
              })
              this.mapConfig.police_track = true
              this.mapConfig.map.clearMap()
              this.mapConfig.oldZoom = this.mapConfig.map.getZoom()
              this.mapConfig.oldCenter = this.mapConfig.map.getCenter()
              this.personIcon()
            }else{
              this.$message.error('暂无轨迹信息！')
            }
          }
        })
      }
    },

    // -----------------  标记  --------------

    /* 添加标记 */
    addMarker(data) {
      let map = this.mapConfig.map
      let AMarker = new AMap.Marker({
        position: [data.longitude?data.longitude:0 , data.latitude?data.latitude:0],
        content: this[data.click](data),
        offset: new AMap.Pixel(-15, -15)
      })

      map.add(AMarker);

      this.mapConfig[data.marker_name].push(AMarker)

      AMarker.on('click', () => {
        this.markerClick(data)
      })

      AMarker.on('mouseover', () => {
        this.markerHover(AMarker, data)
      })
    },

    /* 标记点击事件 */
    markerClick(data) {
      let map = this.mapConfig.map
      const gather = ['camera_gather', 'help_event_gather']
      if (gather.includes(data.type)) {  // 聚合
        let zoom = this.mapConfig.zoom + 2 > 14 ? 14 : this.mapConfig.zoom + 2
        map.setZoom(zoom)
        map.setCenter([data.longitude, data.latitude])
        this.mapConfig.areaId = data.areaId
      }
      if (data.type === 'camera') {
        this.getCameraDom(data.id)
      }
    },

    /* 标记点hover事件*/
    markerHover(AMarker, data) {
      const icon_types = ['event_help', 'alarm', 'police','camera']
      if (icon_types.includes(data.type)) {
        this.addTooltip(AMarker, data)
      }
    },

    /* 添加标记点描述 */
    addTooltip(AMarker, data) {
      let tooltipOffset = data.tooltipOffset
      let offsetX = tooltipOffset && tooltipOffset.offsetX ? tooltipOffset.offsetX : 240
      let offsetY = tooltipOffset && tooltipOffset.offsetY ? tooltipOffset.offsetY : 0
      if(data.type=='camera'){
        this.createCameraTooltip(data,offsetX,offsetY);
      }else{
        this.mapConfig.InfoWindow = new AMap.InfoWindow({
          isCustom: true,
          closeWhenClickMap: true,
          position:[data.longitude , data.latitude],
          content: this[data.hover](data),
          offset: new AMap.Pixel( offsetX,  offsetY)
        })
        this.mapConfig.InfoWindow.open(this.mapConfig.map)

        if(data.type === 'police') {
          return
        }
        AMarker.on('mouseout', () => {
          this.mapConfig.map.remove(this.mapConfig.InfoWindow)
        })
      }
    },

    // 绘制轨迹
    personIcon() {
      let data = this.mapConfig.police_data
      new AMap.Polyline({
        map: this.mapConfig.map,
        path: data.position,
        showDir:true,
        strokeColor: "#ff0002",  //线颜色
        strokeOpacity: 0.8,     //线透明度
        strokeWeight: 6,      //线宽
        strokeStyle: "solid"  //线样式
      });

      let personIconStart = new AMap.Marker({
        position: data.position[0],
        content: `<p class="track_icon">起</p>`,
        offset: new AMap.Pixel(-15, -50)
      })

      carInfo = new AMap.Marker({
        position: data.position[0],
        content: `<img style="height: 50px;border-radius: 50%" src="${data.portrait}">`,
        offset: new AMap.Pixel(-25, -15)
      })

      let personIconEnd = new AMap.Marker({
        position: data.position[data.position.length - 1],
        content: `<p class="track_icon">终</p>`,
        offset: new AMap.Pixel(-25,-15)
      })

      let markers = [personIconStart, personIconEnd, carInfo]
      markers.forEach(item => {
        item.on('click', () => {
          this.clearTrack(markers)
        })
      })

      this.mapConfig.map.setFitView()
      this.mapConfig.map.add(markers);
      carInfo.moveAlong(data.position, 100);
    },

    // 摄像机播放
    getCameraDom(id) {
      this.$http.post(mapAPI.getRtsp, {cameraIds:[id]}).then(res => {
        if(res.status === 200) {
          if(window.QCefClient) {

            for (let i = 0; i < res.result.length; i++) {
              res.result[i].storageUrl = GISApi.storageStatistics;
            }
            window.QCefClient.invokeMethod('QCef_Play_Rtsp',JSON.stringify({list: res.result}))
          }
        }
      })
    },

    /* 标记 */
    markerIcon(data) {
      let domDiv = document.createElement("div");
      let oDiv = document.createElement("div");
      domDiv.className = 'droplet droplet1'
      domDiv.style.backgroundColor = data.bgColor
      const Img = new Image()
      Img.style.width = '22px'
      Img.src = data.img

      oDiv.appendChild(Img)
      domDiv.appendChild(oDiv)
      return domDiv
    },

    /* 聚合标记 */
    gatherMarker(data) {
      let domDiv = document.createElement("div");
      domDiv.className = 'droplet'
      domDiv.style.backgroundColor = data.bgColor || 'rgba(253,82,0,0.8)'

      let domP = document.createElement("p");

      let domSpan = document.createElement("span");
      domSpan.style.width = '40px'
      domSpan.innerText = data.num

      if(data.name) {
        let domSpan1 = document.createElement("span");
        domSpan1.innerText = data.name
        domSpan1.style.fontSize = '12px'
        domSpan1.style.width = '40px'
        domP.appendChild(domSpan1)
      }

      domP.appendChild(domSpan)
      domDiv.appendChild(domP)
      return domDiv
    },

    /* 事件信息框 */
    createEventTooltip(data) {
      const oDiv = document.createElement('div')
      oDiv.className = 'tooltip'
      oDiv.innerHTML = `<div class="tooltip-info">
                    <p><span>事件名称</span>：<span>${data.name}</span></p>
                    <p><span>内容</span>：<span>${data.content}</span></p>
                    <p><span>地址</span>：<span>${data.address}</span></p>
                </div>`

      return oDiv
    },
    /*摄像头信息框*/
    createCameraTooltip(data,offsetX,offsetY) {
      this.$http.get(GISApi.getStatistics, {
        params: {
          id: data.id
        }
      }).then(res => {
        if (res.status === 200) {
          let result = res.result;
          const oDiv = document.createElement('div');
          oDiv.className = 'tooltip';
          oDiv.innerHTML = `<div class="tooltip-info">
						    <p><span>名称</span>：<span>${result.name}</span></p>
						    <p><span>播放时长</span>：<span>${result.playTime?result.playTime:'-'}</span></p>
						    <p><span>访问次数</span>：<span>${result.vv}</span></p>
						    <p><span>事件处理人次数</span>：<span>${result.eventNum}</span></p>
						</div>`
          this.mapConfig.InfoWindow = new AMap.InfoWindow({
            isCustom: true,
            closeWhenClickMap: true,
            position:[data.longitude , data.latitude],
            content: oDiv,
            offset: new AMap.Pixel( offsetX,  offsetY)
          })
          this.mapConfig.InfoWindow.open(this.mapConfig.map)

          if(data.type === 'police') {
            return
          }
          // return oDiv
        }
      })
    },

    /* 人员信息框 */
    createPoliceTooltip(data) {
      const t = this
      const tooltipBox = document.querySelector('#user-tooltip')
      this.mapConfig.police_data = data
      t.mapConfig.show_police_tooltip = true
      return tooltipBox
    },

    /* 摄像头标记（清除） */
    clearCameraMarker() {
      this.mapConfig.map.remove(this.mapConfig.camera_marker)
      this.mapConfig.camera_marker = []
    },

    /* 摄像头聚合标记 （清除） */
    clearCameraGatherMarker() {
      this.mapConfig.map.remove(this.mapConfig.camera_gather_marker)
      this.mapConfig.camera_gather_marker = []
    },

    /* 摄像头标记（清除） */
    clearHelpEventMarker() {
      this.mapConfig.map.remove(this.mapConfig.event_help_marker)
      this.mapConfig.event_help_marker = []
      this.cameraDataList=[];
    },

    /* 摄像头聚合标记 （清除） */
    clearEventHelpGatherMarker() {
      this.mapConfig.map.remove(this.mapConfig.event_help_gather_marker)
      this.mapConfig.event_help_gather_marker = []
    },

    /* 报警事件聚合标记（清除）*/
    clearEventAlarmGatherMarker() {
      this.mapConfig.map.remove(this.mapConfig.event_alarm_gather_marker)
      this.mapConfig.event_alarm_gather_marker = []
    },

    /* 报警事件（清除）*/
    clearAlarmMarker() {
      this.mapConfig.map.remove(this.mapConfig.event_alarm_marker)
      this.mapConfig.event_alarm_marker = []
    },

    /* 出警人员（清除）*/
    clearPoliceMarker() {
      this.mapConfig.map.remove(this.mapConfig.police_marker)
      this.mapConfig.police_marker = []
    },

    /* 清除轨迹 */
    clearTrack(marker) {
      marker.forEach(item => {
        this.mapConfig.map.remove(item)
      })
      this.mapConfig.police_track = false
      this.mapConfig.map.setZoom(this.mapConfig.oldZoom)
      this.mapConfig.map.setCenter(this.mapConfig.oldCenter)
    }
  }
}
</script>

<style lang="less">
.command-center-map {
  .null-info{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 90px);
    .iconfont{
      font-size: 90px;
      color: #0499e7;
    }
  }
  .droplet {
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: rotate(45deg);
    border-radius: 25px 25px 0 25px;
    background-color: #07C;
    &.droplet1 {
      width: 40px;
      height: 40px;
      img {
        transform: rotate(-45deg);
      }
      div {
        background-color: #fff;
        border-radius: 50%;
        height: 30px;
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    p{
      transform: rotate(-45deg);
      display: block;
      color: #fff;
      span{
        display: block;
        text-align: center;
      }
    }
  }

  .tooltip {
    position: relative;
    .tooltip-info {
      width: 300px;
      min-height: 150px;
      padding: 20px 10px;
      opacity: 0;
      border-radius: 5px;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.7);
      animation: hide 0.3s linear 0.4s;
      animation-fill-mode: forwards;
      color: #ffffff;
      font-size: 14px;
      p {
        display: flex;
        padding: 2px 0;
        span:first-child {
          width: 80px;
          flex-shrink: 0;
          text-align: justify;
          text-align-last: justify;
        }
      }
    }
  }

  .tooltip:before, #user-tooltip:before {
    content: '';
    border: 1px solid rgb(38 111 255 / 0.8);
    position: absolute;
    bottom: 20px;
    left: -96px;
    width: 0px;
    transform: rotate(-45deg);
    animation: addWidth 0.2s linear;
    animation-fill-mode: forwards
  }

  .tooltip:after, #user-tooltip:after {
    content: '';
    border: 1px solid rgb(38 111 255 / 0.8);
    position: absolute;
    bottom: 39px;
    left: -52px;
    width: 0px;
    animation: addWidth 0.2s linear 0.2s;
    animation-fill-mode: forwards
  }

  #user-tooltip {
    display: flex;
    position: relative;
    padding: 30px 20px 50px;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.7);
    color: #ffffff;
    &:after {
      width: 50px;
      animation: '';
    }
    &:before {
      width: 50px;
      animation: '';
    }
    i {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 24px;
      cursor: pointer;
    }
    img{
      width: 100px;
      height: 100px;
      margin-right: 10px;
      border-radius: 3px;
    }
    button {
      width: 100px;
      height: 30px;
      color: #ffffff;
      border: none;
      cursor: pointer;
      outline: none;
      position: absolute;
      bottom: 10px;
      left: 20px;
      font-size: 14px;
      background-color: #05bf45;
      border-radius: 3px;
    }
    div{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p {
        display: flex;
        align-items: center;
        padding: 5px 0;
        span:first-child {
          width: 80px;
          flex-shrink: 0;
          text-align: justify;
          text-align-last: justify;
        }
        span:last-child {
          margin-left: 10px;
        }
      }
    }
  }

  .track_icon {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: blue;
    color: #ffffff;
    border-radius: 50%
  }

  @keyframes addWidth{
    0% {
      width: 0;
    }
    100% {
      width: 50px;
    }
  }

  @keyframes hide{
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}

</style>

<style scoped lang="less">
@import "command-center-map.less";
</style>
